module.exports = __webpack_public_path__ + "img/bk2Mobile.01dbb232.jpg";